import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { Text } from "../";

var Paragraph = function Paragraph(props) {
  return /*#__PURE__*/React.createElement(Text, _extends({
    as: "p",
    m: 0,
    mb: 2
  }, props));
};

Paragraph.propTypes = Text.propTypes;
export default Paragraph;